// Filename - App.js

import React, { useState, useEffect,  useContext } from "react";
import { BlockPicker } from "react-color";
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  BrowserRouter as Router,
  Link,
  Navigate,
} from "react-router-dom";
import Iconupload from "./components/iconupload/Iconupload.js";
import IconGroup from "./components/IconGroups/IconGroup.js";
import UserManagement from "./components/userManagement/userManagement.js";
// Import scss file
import Master from "./utils/Master.js";
import "./App.scss";
import { ThemeProvider, CssBaseline } from "@mui/material";
import Notifications from "react-notify-toast";
import theme from "./theme.js";
import Grouplist from "./components/grouplist/Grouplist.js";
import Certificate from "./components/certificate/Certificate.js";
import Header from "./components/header/Header.js";
import Createandgen from "./components/createandgen/Createandgen.js";
import Certificatesissued from "./components/certificatesissued/Certificatesissued.js";
import Csvdata from "./components/csvdata/Csvdata.js";
import LoginPage from "./components/LoginPage/LoginPage.js";
import CourseDetails from "./components/coursedetails/CourseDetails.js";
import ProctedRoutes from "./Outlet.js";

export default function App() {
  const {  token, refreshToken } = useContext(Master);
  return (
    <div className="App">
      {(token || refreshToken) ? <Header /> : null}
      <Notifications />
      <Routes>
        <Route path="/certificate/:id" element={<Certificate />} />
        <Route path="/login" element={<LoginPage />} />
        <Route element={<ProctedRoutes />}>
          <Route path="/" element={<Grouplist />} />
          
          <Route path="/course" element={
            <ThemeProvider theme={theme}>
            <CssBaseline /> {/* Ensures consistent base styles */}
            <CourseDetails />
            </ThemeProvider>
            } />
        
          <Route path="/addicons" element={<Iconupload />} />
          <Route path="/userManagement" element={
            <ThemeProvider theme={theme}>
                 <UserManagement />
            </ThemeProvider>} />
          <Route path="/icongroups" element={<Grouplist />} />
          <Route path="/addicongroups" element={<IconGroup />} />
          <Route path="/issuedcertificates" element={<Certificatesissued />} />
          <Route path="/new" element={<Createandgen />} />
          <Route path="/certificate/*" element={<Certificate />} />
          <Route path="/" element={<Navigate replace to="/issues" />} />
       
          
        </Route>
      </Routes>
    </div>
  );
}
